module.exports = __webpack_public_path__ + "img/account_money_send.9ae2a099.svg";